import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-time-schedule-icon',
  templateUrl: './code-time-schedule.component.html'
})
export class CodeTimeScheduleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
